import { gql } from "@apollo/client";

export const GET_ADJUSTMENT_CATEGORIES_LOOKUP = gql`
  query AdjustmentCategoriesLookup {
    masterDataAdjustmentCategoriesLookup {
      count
      items {
        id
        categoryName
        categoryKey
      }
    }
  }
`;
